import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logError } from "@/lib/logger";

/** Encapsulates the current user's scenarios + incidents fetching for Dashboard.jsx. */
export function useMyActivity(user) {
  const [scenarios, setScenarios] = useState([]);
  const [incidents, setIncidents] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const [scenariosRes, incidentsRes] = await Promise.all([
        api.get("/scenarios", { params: { limit: 200 } }),
        api.get("/incidents/mine"),
      ]);
      setScenarios(scenariosRes.data.filter((s) => s.user_id === user.id));
      setIncidents(incidentsRes.data);
    } catch (e) {
      logError(e);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  return { scenarios, incidents, loading };
}
